/**
 * 组件内-空版块盒子
 * 说明：通过组件定义的handle绑定并内嵌当前页内对应组件
 * 使用示例见：https://alidocs.dingtalk.com/i/nodes/amweZ92PV6vXPzezU2kpv0bYVxEKBD6p
 */

import './index.less';

export function RenderEmptyBlockBox() {
	document.addEventListener('DOMContentLoaded', function () {
		// 获取所有.empty-block-box 元素
		const emptyBlockBoxes = document.querySelectorAll('.empty-block-box');
		if (emptyBlockBoxes.length > 0) {
			emptyBlockBoxes.forEach(emptyBlockBox => {
				const currHandle = emptyBlockBox.getAttribute('target');
				// 获取对应的.embed-component 元素
				const sourceDOM = document.querySelector(`.embed-component[data-handle="${currHandle}"]`);
				if (sourceDOM && !sourceDOM?.dataset?.manualHandle) {
					sourceDOM.style.display = sourceDOM.getAttribute('data-display') || 'block';
					let sourceComponent = sourceDOM.parentElement;
					emptyBlockBox.innerHTML = '';
					emptyBlockBox.appendChild(sourceComponent);
				} else {
					emptyBlockBox.style.display = 'none'
				}
			});
		}
	});
}
